import { render } from "./SuspensionsList.vue?vue&type=template&id=16826fa0&scoped=true"
import script from "./SuspensionsList.vue?vue&type=script&lang=js"
export * from "./SuspensionsList.vue?vue&type=script&lang=js"

import "./SuspensionsList.vue?vue&type=style&index=0&id=16826fa0&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16826fa0"]])

export default __exports__